module.exports = __webpack_public_path__ + "static/media/truck-type-w.68f53c73.svg";